import { useAuth0 } from '@auth0/auth0-react';

export default function AccessDeniedPage() {
  const { logout } = useAuth0();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-red-50 to-orange-50">
      <div className="text-center max-w-md px-6">
        <div className="mb-6">
          <div className="inline-block p-3 bg-red-100 rounded-full">
            <svg
              className="w-12 h-12 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4v2m0 0v2m0-6v-2m0 6v2"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"
              />
            </svg>
          </div>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-2">Access Denied</h1>

        <p className="text-gray-600 mb-4">
          Your account is not authorized to access this application. Please contact your administrator if you
          believe this is an error.
        </p>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left">
          <p className="text-sm text-blue-900">
            <span className="font-semibold">What to do:</span>
            <br />
            Please reach out to the application administrator with your email address to request access.
          </p>
        </div>

        <div className="flex gap-3 flex-col">
          <button
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            className="px-6 py-2 bg-brand-600 text-white font-medium rounded-lg hover:bg-brand-700 transition-colors"
          >
            Sign Out
          </button>

          <a
            href="/"
            className="px-6 py-2 bg-gray-200 text-gray-900 font-medium rounded-lg hover:bg-gray-300 transition-colors"
          >
            Return Home
          </a>
        </div>
      </div>
    </div>
  );
}
